import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { LicenseKeyType } from 'src/models/ts/license-key-type.model';

@Injectable({
  providedIn: 'root'
})
export class LicenseApiService {
  public constructor(private http: HttpClient) {
  }

  public hasLicense(licenseKeyType: LicenseKeyType): Observable<boolean> {
    return this.http.get<boolean>(`api/validlicense/${licenseKeyType}`);
  }
}
